// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeLayout_wrapper__wr4oV","container":"HomeLayout_container__jXNd9"};